export default {
  name: 'oPolaroid',
  props: {
    src: String
  }
};
